// StarkShell — the chrome every stark page shares: the full-bleed dark ground with
// the blueprint grid, the top-nav, and the footer. Inner marketing pages render
// their sections as children; the shell handles background, nav, and footer so the
// global Midnight Header stays hidden on these routes (see App.js / Header.jsx).
import React from "react";
import StarkNav from "./StarkNav";
import StarkFooter from "./StarkFooter";
import "./stark.css";

export default function StarkShell({ children }) {
  return (
    <div className="sk-root">
      <div className="sk-fade" />
      <div className="sk-wrap">
        <StarkNav />
        {children}
        <StarkFooter />
      </div>
    </div>
  );
}
